/**
 * @file paddlehub demo ai写作
 * @author FengGuang(fengguang01@baidu.com)
 */
import AiWriting from './AiWriting';
import './style.less';

export default AiWriting;
